import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "./link";

interface ILink {
  icon: any;
  title: string;
  url: string;
  newPage?: boolean;
  submenus?: ILink[];
  setOpened?: any;
}

export const ExpendableLink: React.FC<ILink> = ({
  icon,
  title,
  url,
  submenus = [],
  setOpened = () => null,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpened, setIsOpened] = React.useState(false);

  React.useEffect(() => {
    const submenuIsOpened = submenus
      ?.map((menu) => menu.url)
      .includes(location.pathname);

    if (submenuIsOpened) {
      setIsOpened(true);
      setOpened(true);
    }
  }, []);

  React.useEffect(() => {
    window.scroll(0, 0);
  }, [location]);

  const isActive = location.pathname === url || location.pathname.startsWith(url + '/');

  return (
    <div>
      <div
        onClick={() => navigate(url)}
        className={`
          group relative flex items-center cursor-pointer px-3 py-2.5 mb-1
          rounded-md transition-all duration-200
          ${
            isActive
              ? "bg-primary-600 text-white shadow-md"
              : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
          }
        `}
      >
        <Link to={url} className="flex flex-1 items-center gap-3">
          <span className={`
            inline-flex items-center justify-center
            ${isActive ? "text-white" : "text-gray-500 group-hover:text-gray-700"}
          `}>
            {icon}
          </span>
          <span className={`
            font-medium text-sm
            ${isActive ? "text-white" : "text-gray-700 group-hover:text-gray-900"}
          `}>
            {title}
          </span>
        </Link>

        {submenus?.length > 0 && (
          <span
            className={`inline-block ml-auto transition-all p-1 ${
              isOpened ? "" : "-rotate-90"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              setIsOpened((prev) => !prev);
            }}
          >
            <svg
              className={`w-3 h-3 ${isActive ? "text-white" : "text-gray-400"}`}
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.08329 0.666626C8.74996 0.333293 8.24996 0.333293 7.91663 0.666626L4.99996 3.58329L2.08329 0.666626C1.74996 0.333293 1.24996 0.333293 0.916626 0.666626C0.583293 0.999959 0.583293 1.49996 0.916626 1.83329L4.41663 5.33329C4.58329 5.49996 4.74996 5.58329 4.99996 5.58329C5.24996 5.58329 5.41663 5.49996 5.58329 5.33329L9.08329 1.83329C9.41663 1.49996 9.41663 0.999959 9.08329 0.666626Z"
                fill="currentColor"
              ></path>
            </svg>
          </span>
        )}

        {/* Active Indicator */}
        {isActive && (
          <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-white rounded-r-full" />
        )}
      </div>

      {/* Submenus */}
      <div className={`${isOpened ? "block" : "hidden"} pl-6 mt-1 space-y-1`}>
        {submenus?.map((menu, index) => (
          <ExpendableLink
            key={`${menu.url}-${index}`}
            setOpened={setIsOpened}
            icon={menu.icon}
            title={menu.title}
            url={menu.url}
            submenus={menu.submenus}
            newPage={menu.newPage || false}
          />
        ))}
      </div>
    </div>
  );
};
